import styled from '@emotion/styled';

const IHRimg = styled('div')({
  opacity: 0.5,
  textAlign: 'center',
  width: '100%',
});

export default IHRimg;
